import * as React from 'react'
import config from 'config'
import Scale, { ColourChip } from 'components/scale'
import './styles.scss'

export function Legend () {
  return (
    <div className='legend-block'>
      <Scale title={'Anteil der Angebote im gewählten Segment'} />
      <ColourChip
        single
        colour={config.invalidColor}
        legend={'Keine Angebote'}
      />
      <ColourChip single legend={'Weniger als 80 Angebote'}>
        <svg
          viewBox='0 0 3 3'
          style={{ width: '3ex', height: '3ex' }}
          preserveAspectRatio='xMidYMid meet'
        >
          <defs>
            <pattern
              id={`diagonalHatch`}
              width={0.5}
              height={0.5}
              patternTransform='rotate(45 0 0)'
              patternUnits='userSpaceOnUse'
            >
              <line
                x1='0'
                y1='0'
                x2='0'
                y2={2}
                vectorEffect='non-scaling-stroke'
                stroke='white'
                strokeOpacity='0.7'
                strokeWidth={1}
              />
            </pattern>
          </defs>
          <rect x={0} y={0} width={3} height={3} fill='#5A686D' />
          <rect x={0} y={0} width={3} height={3} fill='url(#diagonalHatch)' />
        </svg>
      </ColourChip>
    </div>
  )
}
